import { render, staticRenderFns } from "./SiteNotice.vue?vue&type=template&id=bca0d6a0&scoped=true"
import script from "./SiteNotice.vue?vue&type=script&lang=js"
export * from "./SiteNotice.vue?vue&type=script&lang=js"
import style0 from "./SiteNotice.vue?vue&type=style&index=0&id=bca0d6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca0d6a0",
  null
  
)

export default component.exports